// extracted by mini-css-extract-plugin
module.exports = {"form":"SubscribeForm_form__XE4iL","button":"SubscribeForm_button__8Zd3l","text":"SubscribeForm_text__mBKAM"};